import inputData from './inputData/post-event-feedback-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'post-event-feedback-survey',
  title: 'Post-Event Feedback Survey',
  description: 'Evaluate how your event performed and gather insights that make planning the next one even easier.',
  image: '/images/templates/post-event-feedback-survey.png',
  tags: ['get-feedback', 'plan-events', 'engage-audience'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

